import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchTestimonials = createAsyncThunk(
  'testimonials/fetchTestimonials',
  async (userData, thunkAPI) => {
    const BASE_URL = 'https://dreamonelove.com';
    const END_POINT = '/gloriabrides/services/storyAPI';
    const url = BASE_URL + END_POINT;

    const testimonialData = {
      cmd: 'CMD_GET_ALL_STORIES',
      count: '6',
      retrieveCount: 'true',
      start: 0,
    };

    try {
      const response = await axios.post(url, testimonialData);
      return response.data.result.storyList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);

export const fetchTestimonialId = createAsyncThunk(
  'testimonialId/fetchTestimonialId',
  async (storyId, thunkAPI) => {
    const BASE_URL = 'https://dreamonelove.com';
    const END_POINT = '/gloriabrides/services/storyAPI';
    const url = BASE_URL + END_POINT;

    const testimonialIdData = {
      cmd: 'CMD_GET_DETAIL_STORY',
      storyId: storyId,
    };

    try {
      const response = await axios.post(url, testimonialIdData);
      return response.data.result;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.message);
    }
  },
);
